import {INPUT_ID} from './constants.js';
import EffectEdge from './EffectEdge.js';
import {AbstractParameter} from 'parameters/AbstractParameter.js';

export default superclass => class extends superclass  {
    // effect.id -> list of edges
    configurations = [];

    set currentConfiguration(config) {
        this.configurationParameter.set(config);
    }

    get currentConfiguration() {
        return this.configurationParameter.get();
    }

    initializeConfigurations(adjacencyLists, register=true) {
        this.loaded = true;
        this.oldConfiguration = 0;
        this.configurations = [];
        this.configurations[0] = adjacencyLists;
        if (register) {
            this.configurationParameter = new AbstractParameter(
                'Configuration', this,
                (a, config) => {
                    this.switchToConfiguration(config);
                },
                {
                    documentation: "",
                    defaultValue: 0,
                    uxAutomatable: false
                });
            this.registerParameter(this.configurationParameter);
        }
    }

    saveCurrentConfiguration() {
        let currentConfiguration  = this.currentConfiguration === undefined ? 1 :
            this.currentConfiguration;
        this.configurations[currentConfiguration] = {... this.adjacencyLists};
        return currentConfiguration;
    }

    newConfiguration(isCopy=true, replace=false) {
        let old = this.currentConfiguration;
        let adjacencyLists = isCopy ?
            this.copyAdjacencyLists(this.adjacencyLists) :
            {};
        this.configurations.push(adjacencyLists);
        this.currentConfiguration = this.configurations.length - 1;

        if (replace) {
            this.adjacencyLists = adjacencyLists;
        }
        return old;
    }

    switchToConfiguration(configNumber) {
        if (this.configurationParameter === undefined) {
            
            return;
        }

        if (this.oldConfiguration === configNumber) {
            return;
        }

        // first clear out current configuration
        this.clearConfiguration(this.oldConfiguration);

        // then load the new configuration and set it as
        // currentConfiguration

        let config = this.configurations[configNumber];
        this.loadConfig(config);
        this.oldConfiguration = this.currentConfiguration;
    }

    configNames(config=this.adjacencyLists) {
        let n ={};
        let i=0;
        for (let id in config) {
            let effect = this.effects.find(e => e.id === id);
            n[effect.name + '-' + i] = config[id];
            i++;
        }
        return n;
    }

    loadConfig(config) {
        this.adjacencyLists = {};
        for (let id in config) {
            for (let i in config[id]) {
                let node = parseInt(id) === INPUT_ID ?
                    this.inputNode :
                    this.effects.find(e => e.id === id);
                let edge = config[id][i];
                if (node !== undefined) {
                    this.connectEdge(node, edge);
                }
            }
        }
    }

    clearConfiguration(configNumber=this.oldConfiguration) {
        // first make a shallow copy of current config
        let copiedConfiguration = this.copyAdjacencyLists(
            this.adjacencyLists, true);

        for (let effectId in this.adjacencyLists) {
            let effect = this.effects.find(e => e.id === effectId);
            let edges = [... this.adjacencyLists[effectId]];
            edges.forEach(
                edge => {
                    this.deleteEdge(edge);
                });
        }

        if (this.loaded) {
            // things get bad if we try to do this before fromJson completes
            this.configurations[configNumber] = copiedConfiguration;
        }
    }

    copyAdjacencyLists(adjacencyLists=this.adjacencyLists, isShallow=false) {
        let copy = {};
        for (let effectId in adjacencyLists) {
            if (isShallow) {
                copy[effectId] = [... adjacencyLists[effectId]];
            } else {
                copy[effectId] = adjacencyLists[effectId].map(
                    e => e.getCopy());
            }
        }
        return copy;
    }

    getConfigurationJson() {
        let json = [];
        for (let i in this.configurations) {
            let adjacencyLists = this.configurations[i];
            let config = {};
            for (let id in adjacencyLists) {
                config[id] = adjacencyLists[id].map(
                    e => e.getJson(this));
            }
            json.push(config);
        }

        return json;
    }

    loadConfigurationJson(json) {
        let configurations = [];
        for (let i in json) {
            let config = json[i];
            let adjacencyLists = {};
            for (let id in config) {
                let list = [];
                for (let i in config[id]) {
                    let edge = new EffectEdge(undefined, this.sequencerEngine);
                    edge.fromJson(config[id][i], this);
                    list.push(edge);
                }
                adjacencyLists[id] = list;
            }
            configurations.push(adjacencyLists);
        }
        this.configurations = configurations;
    }
}
